@if (hasAnyContent) {
    <!-- Need this scroll view around the sortable for dragging if we have more themes within a zone or we can't possibly order those wrapped zone -->
    @if (isEditing) {
        <dx-scroll-view [scrollByContent]="true"
                        direction="horizontal">
            <dx-sortable [ngClass]="isDraggingTheme && isHorizontal ? 'dragging-horizontal-goals-zone' : isSingleColumn ? 'goals-zone-single-column' : 'goals-zone'"
                         handle="#categoryGripper"
                         [itemOrientation]="categoryDragOrientation"
                         [data]="orderedThemeNames"
                         [allowDropInsideItem]="false"
                         (onDragStart)="onThemeDragStart($event)"
                         (onDragChange)="preventDragToUncategorisedArea($event)"
                         (onReorder)="reorderThemes($event)">
                @for (theme of orderedThemeNames; track theme) {
                    <adapt-collapsible-dashboard-element [name]="theme"
                                                         [isExpandable]="hasDisplayContent(theme)"
                                                         [isCollapsible]="hasDisplayContent(theme)"
                                                         [collapsed]="!hasDisplayContent(theme)"
                                                         [handleId]="isThemeDraggable ? 'categoryGripper' : undefined"
                                                         class="card category"
                                                         [draggable]="false"
                                                         [overrideStyleClass]="ZoneClass[zone!]"
                                                         [ngClass]="{
                            'category-multi-columns': !isSingleColumn,
                            'category-single-column': isSingleColumn,
                        }">
                        @if (getMenuItemsForTheme(theme); as menuItems) {
                            <ng-container adapt-collapsible-header-action-right>
                                @if (isEditing && menuItems[0].items?.length) {
                                    <adapt-menu class="ms-auto me-2"
                                                [items]="menuItems"
                                                data-tour="theme-action-menu"></adapt-menu>
                                }
                            </ng-container>
                        }
                        @if (!includesThemesView && getThemeByName(theme)?.description) {
                            <adapt-display-theme-info adapt-collapsible-header-action
                                                      class="ms-1"
                                                      [theme]="getThemeByName(theme)"></adapt-display-theme-info>
                        }
                        @if (hasDisplayContent(theme)) {
                            <div class="d-flex flex-column pt-2 transparent-background">
                                @if (includesThemesView) {
                                    @if (getThemeByName(theme)?.description; as description) {
                                        <div [froalaView]="description"></div>
                                    } @else {
                                        <span>No description. Edit theme to enter a description.</span>
                                    }
                                }
                                <div [ngClass]="{ 'mt-2': includesThemesView }">
                                    <!-- This this div outside dx-sortable to avoid having goals sticking to the edge of the drop zone -->
                                </div>
                                @if (includesSWTInputsView && categorisedSWTInputs[theme]; as zoneInputLocations) {
                                    <div class="p-2 zone-container"
                                         [className]="ZoneClass[zone!]"
                                         [ngClass]="{
                                            'mt-2': hasDisplayContent(theme, StrategicViewOption.SWTInputs),
                                            'categorised-drag-border': isDraggingInputTheme === theme && draggingInputType === CanvasType.StrengthsWeaknessesTrends,
                                        }">
                                        <div class="container-label pb-1">
                                            <div class="category-label">
                                                <div class="fa fa-bolt"></div>
                                                <b class="px-1">SWT</b>
                                            </div>
                                        </div>
                                        <dx-sortable class="d-flex flex-column"
                                                     handle="#inputGripper"
                                                     [data]="zoneInputLocations"
                                                     (onDragStart)="onInputDragStart($event)"
                                                     (onDragEnd)="reorderInput($event)">
                                            @for (inputLocation of zoneInputLocations; track inputLocation; let first = $first) {
                                                <adapt-strategic-input class="input-swt"
                                                                       [input]="inputLocation.input"
                                                                       [showCanvasNameInContent]="true"
                                                                       [isCollapsible]="true"
                                                                       [isDetachable]="isEditing"
                                                                       [showIcon]="true"
                                                                       [tooltip]="InputTypeMetadata[inputLocation.input.type].tooltip"
                                                                       tooltipPlacement="top-left"
                                                                       [overrideStyleClass]="ZoneClass[zone!]"
                                                                       (detach)="detachSWTInputLocation(inputLocation)"
                                                                       [handleId]="isEditing && zoneInputLocations.length > 1 ? 'inputGripper' : undefined"
                                                                       [ngClass]="{
                                                        'mt-2': !first,
                                                    }"></adapt-strategic-input>
                                            }
                                        </dx-sortable>
                                    </div>
                                }
                                @if (includesCAInputsView && categorisedCAInputs[theme]; as zoneInputLocations) {
                                    <div class="p-2 zone-container"
                                         [className]="ZoneClass[zone!]"
                                         [ngClass]="{
                                            'mt-2': hasDisplayContent(theme, StrategicViewOption.CAInputs),
                                            'categorised-drag-border': isDraggingInputTheme === theme && draggingInputType === CanvasType.CompetitorAnalysis,
                                        }">
                                        <div class="container-label pb-1"
                                             [ngClass]="{
                                                'single-ca': zoneInputLocations.length === 1,
                                            }">
                                            <div class="category-label">
                                                <div class="fa fa-boxing-glove"></div>
                                                <b class="px-1">Competitor analysis</b>
                                            </div>
                                        </div>
                                        <dx-sortable class="d-flex flex-column"
                                                     handle="#CAInputGripper"
                                                     [data]="zoneInputLocations"
                                                     (onDragStart)="onInputDragStart($event)"
                                                     (onDragEnd)="reorderInput($event)">
                                            @for (inputLocation of zoneInputLocations; track inputLocation; let first = $first) {
                                                <adapt-strategic-input class="input-ca"
                                                                       [input]="inputLocation.input"
                                                                       [showCanvasNameInContent]="true"
                                                                       [isCollapsible]="true"
                                                                       [isDetachable]="isEditing"
                                                                       [showIcon]="true"
                                                                       [tooltip]="InputTypeMetadata[inputLocation.input.type].tooltip"
                                                                       tooltipPlacement="top-left"
                                                                       [overrideStyleClass]="ZoneClass[zone!]"
                                                                       (detach)="detachCAInputLocation(inputLocation)"
                                                                       [handleId]="isEditing && zoneInputLocations.length > 1 ? 'CAInputGripper' : undefined"
                                                                       [ngClass]="{
                                                        'mt-2': !first,
                                                    }"></adapt-strategic-input>
                                            }
                                        </dx-sortable>
                                    </div>
                                }
                                @if (includesBullseyeView && categorisedBullseyeStatements[theme]; as zoneBullseyeStatementLocations) {
                                    <div class="p-2 zone-container"
                                         [className]="ZoneClass[zone!]"
                                         [ngClass]="{
                                            'mt-2': hasDisplayContent(theme, StrategicViewOption.Bullseye),
                                            'categorised-drag-border': isDraggingBullseyeStatementTheme === theme,
                                        }">
                                        <div class="container-label pb-1">
                                            <div class="category-label">
                                                <div class="fa fa-crosshairs"></div>
                                                <b class="px-1">Bullseye</b>
                                            </div>
                                        </div>
                                        <dx-sortable class="d-flex flex-column"
                                                     handle="#statementGripper"
                                                     [data]="zoneBullseyeStatementLocations"
                                                     (onDragStart)="onBullseyeStatementDragStart($event)"
                                                     (onDragEnd)="reorderBullseyeStatement($event)">
                                            @for (statementLocation of zoneBullseyeStatementLocations; track statementLocation; let first = $first) {
                                                <ng-container [ngTemplateOutlet]="renderBullseyeStatement"
                                                              [ngTemplateOutletContext]="{
                                                        first,
                                                        statementLocation,
                                                        statementCount: zoneBullseyeStatementLocations.length,
                                                    }">
                                                </ng-container>
                                            }
                                        </dx-sortable>
                                    </div>
                                }
                            </div>
                        }
                    </adapt-collapsible-dashboard-element>
                }
            </dx-sortable>
        </dx-scroll-view>
    }
} @else {
    <ng-container *adaptLoading="!isInitialised">
        @if (isEditing && zone === Zone.EconomicEngine && !hasThemes) {
            <div class="alert alert-secondary">There are no strategic themes on your strategic working board - add a strategic theme using
                the button above.</div>
        }
    </ng-container>
}

<ng-template #renderBullseyeStatement
             let-first="first"
             let-statementLocation="statementLocation"
             let-statementCount="statementCount">
    @if (statementLocation?.bullseyeStatement) {
        <div class="bullseye-statement"
             [ngClass]="{ 'mt-2': !first }"
             [className]="ZoneClass[zone!]">
            @if (isEditing && statementCount > 1) {
                <i class="fal fa-grip-dots-vertical pe-1 gripper"
                   id="statementGripper"></i>
            }
            <i class="fal"
               [ngClass]="getQuadrantIcon(statementLocation.bullseyeStatement.quadrant)"
               [adaptTooltip]="getQuadrantTooltip(statementLocation.bullseyeStatement.quadrant)"></i>
            <h5 class="mb-0 flex-grow-1">
                {{ statementLocation.bullseyeStatement.statement }}
            </h5>
            @if (isEditing) {
                <button class="text-black"
                        adaptButton="deleteBorderless"
                        (click)="detachBullseyeStatementLocation(statementLocation)"
                        adaptTooltip="Detach from strategic working board"
                        tooltipPlacement="bottom"></button>
            }
        </div>
    }
</ng-template>
